import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { AssignmentRoleDocument, assignmentRolePullQueryBuilder } from './queryBuilder';

export function assignmentRoleFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<AssignmentRoleDocument> {
  const syncConfig = configBuilder<AssignmentRoleDocument>(RxdbCollectionNameV2.ASSIGNMENT_ROLE);
  doNotAutoSync(syncConfig);

  pull(syncConfig, assignmentRolePullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.ASSIGNMENT_ROLE, replicationState, [sites]);
}
